import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "system-message" }
const _hoisted_2 = {
  key: 0,
  class: "system-message__top-desc"
}
const _hoisted_3 = {
  key: 1,
  class: "system-message__main-title"
}
const _hoisted_4 = {
  key: 2,
  class: "system-message__subtitle"
}
const _hoisted_5 = {
  key: 3,
  class: "system-message__more-desc"
}
const _hoisted_6 = {
  key: 4,
  class: "system-message__actions"
}

import { computed, useSlots } from "vue";

/**
 * Слоты
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-system-message',
  setup(__props) {

const slots = useSlots();
/**
 * Верхняя картинка ли текст
 */
const isTopDescSlot = computed(() => slots && slots.topDescImage && slots.topDescImage());
/**
 * Основной заголовок
 */
const isMainTitleSlot = computed(() => slots && slots.mainTitleSlot && slots.mainTitleSlot());
/**
 * Подзаголовок
 */
const isMainSubtitleSlot = computed(
  () => slots && slots.mainSubtitleSlot && slots.mainSubtitleSlot(),
);
/**
 * Расширенное описание
 */
const isDescriptionSlot = computed(() => slots && slots.descriptionSlot && slots.descriptionSlot());
/**
 * Слот для кнопок и экшенов
 */
const isActionsSlot = computed(() => slots && slots.actionsSlot && slots.actionsSlot());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isTopDescSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "topDescImage")
        ]))
      : _createCommentVNode("", true),
    (isMainTitleSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "mainTitleSlot")
        ]))
      : _createCommentVNode("", true),
    (isMainSubtitleSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "mainSubtitleSlot")
        ]))
      : _createCommentVNode("", true),
    (isDescriptionSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "descriptionSlot")
        ]))
      : _createCommentVNode("", true),
    (isActionsSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "actionsSlot")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})